import { apiAuth } from "../AuthenticateApi";
import { Resource } from "../Constants/ResourceVariable";
import {
  GetSurveyAnswerParams,
  PutSurveyAnswerParams,
  deleteFileParams,
  deleteMultipleFileParams,
  getSurveyParameters,
  postOTPParam,
  resendOTPParam,
} from "../Constants/HandlerTypes";
export const ApiHandler = {
  //api handler for get-survey-answered-questions
  getAnswer: async (
    surveyAnswerDocId: GetSurveyAnswerParams["surveyAnswerDocId"]
  ) => {
    const response = await apiAuth.getApiwithoutAuth(
      Resource.url.getAnswer(surveyAnswerDocId)
    );
    return response.data;
  },
  // api to get survey info
  getSurvey: async (surveyId: string) => {
    const response = await apiAuth.getApiwithoutAuth(
      Resource.url.survey(surveyId)
    );
    return response.data;
  },
  //mfa code to supplier
  supplierMfaEmail: async (documentId: string) => {
    const response = await apiAuth.getApiwithoutAuth(
      Resource.url.mfaEmail(documentId)
    );
    return response.data;
  },
  //api-for-put-answer
  putAnswer: async ({
    surveyAnswerDocId,
    modifiedData,
  }: {
    surveyAnswerDocId?: PutSurveyAnswerParams["surveyAnswerDocId"];
    modifiedData: PutSurveyAnswerParams["modifiedData"];
  }) => {
    const response = await apiAuth.putApiwithoutAuth(
      Resource.url.putAnswer(surveyAnswerDocId),
      modifiedData
    );
    return response.data;
  },
  //api-handler-for-upload-files
  postFiles: async (formData: FormData) => {
    const response = await apiAuth.postApiwithoutEncryption(
      Resource.url.fileUpload,
      formData
    );
    return response.data;
  },
  deleteUploadedFile: async (
    deleteParams: deleteFileParams["deleteParams"]
  ) => {
    const response = await apiAuth.putApiwithoutAuth(
      Resource.url.deleteFile(deleteParams)
    );
    return response.data;
  },
  deleteMultipleUploadedFiles: async (
    deleteParams: deleteMultipleFileParams["deleteParams"]
  ) => {
    const response = await apiAuth.putApiwithoutAuth(
      Resource.url.deleteMultipleFiles,
      deleteParams.deleteData
    );
    return response.data;
  },
  //MFA OTP Post
  postOTP: async (modifiedData: postOTPParam) => {
    const response = await apiAuth.putApiwithoutAuth(
      Resource.url.verifyOTP,
      modifiedData.param
    );
    return response.data;
  },
  //MFA resend OTP
  postResendOTP: async (modifiedData: resendOTPParam) => {
    const response = await apiAuth.postApiwithoutAuth(
      Resource.url.ResendOTP,
      modifiedData
    );
    return response.data;
  },
  //get base survey
  getBaseSurvey: async (
    baseSurveyId: getSurveyParameters["baseSurveyId"],
    companyId: getSurveyParameters["companyId"],
    supplierId: getSurveyParameters["supplierId"]
  ) => {
    const response = await apiAuth.getApiwithoutAuth(
      Resource.url.getBaseSurvey(baseSurveyId, companyId, supplierId)
    );
    return response.data;
  },
};
